import { Alert } from "antd";
import { t } from "i18next";
import * as React from "react";
import { useLocation } from "react-router-dom";
import { PageLayout } from "src/components/PageLayout";

export const NoMatch: React.FC = () => {
  const location = useLocation();
  return (
    <PageLayout title={t("Invalid page URL")}>
      <Alert
        type="warning"
        showIcon
        message={`No match for path ${location.pathname}`}
      />
    </PageLayout>
  );
};
